import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import FaChevronLeft from 'react-icons/lib/fa/chevron-left';
import FaArrowRight from 'react-icons/lib/fa/arrow-right';
import {action, observable} from 'mobx';
import ReactPlayer from 'react-player';
import {FormattedMessage, injectIntl} from 'react-intl';
import VideoPlayer from '../../../components/videoPlayer';
import BaseButton from '../../../components/button/BaseButton';
import SvgIconButton from '../../../components/SvgIconButton';
import infoIcon from '../../../assets/images/info';

const infoIconStyle = {
    width: '10px',
    height: '10px',
    minWidth: '10px',
    minHeight: '10px',
    borderRadius: 0
};


@injectIntl
@observer
class LessonVideoLinkDrawer extends Component {
    @observable placeholder = true;
    @observable linkUrlField = '';
    @observable previewLinkUrlField = '';
    @observable checkVideo = false;
    @observable processing = false;
    @observable errorLink = false;

    @action setPlaceholder = (val) => {
        this.placeholder = val;
    };

    @action setLinkUrl = (e) => {
        this.errorLink = false;
        this.linkUrlField = e.target.value;
    };

    @action saveLinkUrl = (e) => {
        e.preventDefault();
        if (!this.linkUrlField) return;
        this.checkVideo = true;
    };

    @action onReady = () => {
        this.previewLinkUrlField = this.linkUrlField;
        this.setPlaceholder(false);
        // this.linkUrlField = '';
        this.checkVideo = false;
    };

    @action onError = () => {
        this.errorLink = true;
        this.props.createAlertFromMessageId('error', 'createLesson.invalidVideoLink');
        this.checkVideo = false;
    };

    onSaveVideo = () => {
        this.props.onSaveVideo(this.previewLinkUrlField);
        this.props.closePreview();
    };

    render() {
        const {closePreview, intl: {formatMessage: translate}} = this.props;
        return (
            <div className="lesson-recorder">
                <div className="lesson-recorder-close" onClick={closePreview}>
                    <FaChevronLeft className="recorder-close-icon"/>
                    <FormattedMessage id="general.back"/>
                </div>
                <div className="lesson-recorder-wrapper">
                    <div className="lesson-video-placeholder">
                        {this.checkVideo && <div className="circular-loader" />}
                        <div className="video-placeholder-box">
                            {this.checkVideo && <ReactPlayer
                                className="check-video-player"
                                url={this.linkUrlField}
                                onError={this.onError}
                                onReady={this.onReady}
                            />}
                            <div className="video-placeholder-top"/>
                            <div className="video-placeholder-body">
                                {!this.placeholder && <VideoPlayer url={this.previewLinkUrlField}/>}
                            </div>
                            <form className="lesson-video-form" onSubmit={this.saveLinkUrl}>
                                <input
                                    value={this.linkUrlField}
                                    onChange={this.setLinkUrl}
                                    placeholder={translate({id: 'createLesson.videoLinkPlaceholder'})}
                                    type="text"
                                />
                                <button type="submit">
                                    <FaArrowRight/>
                                </button>
                            </form>
                        </div>
                    </div>
                    <div className="lesson-video-actions">
                        {this.errorLink && <div className="file-input-error">
                            <SvgIconButton
                                viewBox="0 0 12 12"
                                icon={infoIcon}
                                buttonStyle={infoIconStyle}
                                hoverColor="none"
                                rippleColor="none"
                                iconStyle={infoIconStyle}
                                containerClass="file-input-error-icon"/>
                            <FormattedMessage id="createLesson.invalidVideoLink"/>
                        </div>}
                        <BaseButton
                            className="lesson-btn"
                            label={translate({id: 'createLesson.saveVideo'})}
                            disabled={this.checkVideo || !this.previewLinkUrlField}
                            onClick={this.onSaveVideo} />
                    </div>
                </div>
            </div>
        );
    }
}

LessonVideoLinkDrawer.propTypes = {
    closePreview: PropTypes.func,
    onSaveVideo: PropTypes.func,
    createAlertFromMessageId: PropTypes.func
};

export default LessonVideoLinkDrawer;
